
import { Vue } from "vue-class-component";

export default class SolarSignupLinkBanner extends Vue {}
